import { Query } from '@varo/graphql-schema-types';
import FetchAccountIDCards from 'services/graphql/queries/FetchAccountIDCards';
import { useFormattedGQLErrors } from 'shared/hooks/errorFormatters/useFormattedGQLErrors';
import { AnyVariables, RequestPolicy, useQuery } from 'urql';

export const useFetchCards = (props?: {
  requestPolicy?: RequestPolicy;
  pause?: boolean;
}) => {
  const { requestPolicy = 'cache-and-network', pause = false } = props || {};

  const [{ data, error, fetching }, refetch] = useQuery<Query, AnyVariables>({
    query: FetchAccountIDCards,
    requestPolicy: requestPolicy ?? 'cache-and-network',
    pause,
  });

  const formattedError = useFormattedGQLErrors({ combinedError: error });

  return {
    data,
    error: formattedError,
    fetching,
    refetch: () => refetch({ requestPolicy: 'network-only' }),
  };
};
